<script lang="ts">
	import { onMount, onDestroy, createEventDispatcher } from "svelte";

	export let id = "";
	export let name = "";
	export let preventDropOnDocument = true;
	export let preventUploadfile = false;

	const dispatch = createEventDispatcher();

	let dragenter = false;
	let fileInput: HTMLInputElement;
	let rootRef: HTMLDivElement;
	function clickHandler() {
		if (preventUploadfile) {
			return;
		}

		fileInput.click();
	}

	function handleFileinputChange(e: Event) {
		const target = e.target as HTMLInputElement;
		if (!target || !target.files) return;
		changeProfilePicture(target.files);

		target.type = "radio";
		target.type = "file";
	}

	function changeProfilePicture(files: FileList) {
		if (files.length !== 1) return;
		const __file = files[0];

		const extMatch = __file.name.match(
			/(\.png|\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG)$/
		);
		if (!extMatch) {
			alert("지원되지 않는 포맷입니다. png,jpg,jpeg만 가능합니다.");
			return;
		}

		dispatch("file-update", __file);
	}

	function getFile(e: any) {
		const transferItems: DataTransferItemList = e.dataTransfer.items;

		for (let i = 0; i < transferItems.length; i++) {
			if (
				transferItems[i].kind == "file" &&
				transferItems[i].type.match("^image/")
			) {
				const __file = transferItems[i].getAsFile();
				if (__file !== null) {
					return __file;
				}
			}
		}
		return null;
	}

	function dropHandler(e: Event) {
		e.preventDefault();
		if (preventUploadfile) {
			return;
		}
		dragenter = false;
		const file = getFile(e);

		if (file === null) {
			return;
		}

		const fileList: FileList = [file] as unknown as FileList;

		changeProfilePicture(fileList);
	}

	function onDocumentDrop(event: Event) {
		if (rootRef && rootRef.contains(event.target as HTMLElement)) {
			// If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
			return;
		}
		event.preventDefault();
		// dragTargetsRef = [];
	}

	function onDocumentDragOver(e: Event) {
		e.preventDefault();
	}

	function onDragenter(e: Event) {
		e.preventDefault();
		dragenter = true;
	}

	function onDragleave(e: Event) {
		e.preventDefault();
		dragenter = false;
	}

	onMount(() => {
		// window.addEventListener("focus", onWindowFocus, false);
		if (preventDropOnDocument) {
			document.addEventListener("dragover", onDocumentDragOver, false);
			document.addEventListener("drop", onDocumentDrop, false);
		}
	});
	onDestroy(() => {
		// window.removeEventListener("focus", onWindowFocus, false);
		if (preventDropOnDocument) {
			document.removeEventListener("dragover", onDocumentDragOver);
			document.removeEventListener("drop", onDocumentDrop);
		}
	});

</script>

<div
	t-id={'dragAndDrop'}
	on:click={clickHandler}
	on:drop={dropHandler}
	on:dragenter={onDragenter}
	on:dragleave={onDragleave}
	bind:this={rootRef}>
	<slot enter={dragenter} />
	<input
		bind:this={fileInput}
		type="file"
		name={name}
		id={id}
		on:change={handleFileinputChange} />
</div>

<style lang="scss">
	div {
		width: 100%;
		height: 100%;

		input {
			display: none;
		}
	}

</style>
